export function initMetaPixel() {
  const w = window as any
  if (w.fbq) return

  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.defer = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  w.fbq('init', '793935510144655')
  w.fbq('track', 'PageView')
}

function generateEventId(): string {
  return `atc_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`
}

function detectLocale(): 'ar' | 'us' {
  if (
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/ar')
  ) {
    return 'ar'
  }
  return 'us'
}

let lastAddToCartTime = 0

export function trackAddToCart() {
  // Deduplication: ignore calls within 2 seconds of each other
  const now = Date.now()
  if (now - lastAddToCartTime < 2000) return
  lastAddToCartTime = now

  const locale = detectLocale()
  const value = locale === 'ar' ? 9997 : 6.36
  const currency = locale === 'ar' ? 'ARS' : 'USD'
  const eventId = generateEventId()

  const w = window as any

  // Use fbq SDK if available, otherwise fall back to image pixel
  if (typeof w.fbq === 'function') {
    try {
      w.fbq(
        'track',
        'AddToCart',
        {
          content_name: 'El Envés del Metabolismo',
          content_type: 'product',
          value: value,
          currency: currency,
        },
        { eventID: eventId },
      )
      return
    } catch (e) {
      // fall through to image fallback
    }
  }

  // Fallback: image pixel (only when SDK unavailable)
  try {
    const PIXEL_ID = '793935510144655'
    const params = new URLSearchParams({
      id: PIXEL_ID,
      ev: 'AddToCart',
      dl: window.location.href,
      rl: document.referrer,
      if: 'false',
      ts: String(now),
      eid: eventId,
      'cd[content_name]': 'El Envés del Metabolismo',
      'cd[content_type]': 'product',
      'cd[value]': String(value),
      'cd[currency]': currency,
    })
    const img = new Image(1, 1)
    img.src = `https://www.facebook.com/tr?${params.toString()}`
  } catch (e) {
    // silently fail
  }
}
